import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function getUnitDetails(locationId: string) {
  return await apiCall.get(`${API_URL.UNIT.DETAILS}${locationId}`);
}
